'use client';

import { useState } from 'react';
import { Image } from 'tdesign-react';
import { MeetingItem } from '../type';
import { getCMSIntlVal, tCMSLineBreak } from '../utils/common';
import { useLocale } from 'use-intl';

interface SessionInfoItemProps {
  item: MeetingItem;
  active?: boolean;
  onChange?: () => void;
}
const SessionInfoItem = ({ active, item, onChange }: SessionInfoItemProps) => {
  const locale = useLocale();
  const { timeText, speakerImgUrl = '', speaker = [] } = item || {};
  const title = tCMSLineBreak(getCMSIntlVal(item, 'title', locale));
  const sharePersonList = speaker.map((item) =>
    getCMSIntlVal(item, 'name', locale)
  );
  const shareTitleList = speaker
    .map((item) => getCMSIntlVal(item, 'discussionTopic', locale))
    .filter((str) => str);
  const bgName = locale === 'en' ? 's-mt-2025' : 's-mt-2025-1';
  return (
    <div
      onMouseEnter={() => {
        onChange?.();
      }}
      className={`
      relative cursor-pointer flex1 min-h-[185px] bg-[#F4F8FF] text-[#121C59] text-[24px] 
      transition-all duration-500 delay-80 transform-gpu ${
        active ? 'min-h-[280px]' : ''
      }`}
      style={{
        background: active
          ? `url(https://cdn-digital.ssv.qq.com/upload//s2025/${bgName}.png) no-repeat center center/cover`
          : undefined,
      }}
    >
      {/* 非hover */}
      <div
        className={`w-full h-full flex items-center justify-between py-[48px] pl-[64px] pr-[105px] ${
          active ? 'invisible absolute' : 'visible relative'
        }`}
      >
        <div className="leading-[1.5] flex-shrink-0 font-tcn1">{timeText}</div>
        <div className="flex-1 flex flex-col ml-[24px] mr-[24px] min-w-0">
          <p className="leading-[1.5] line-clamp-2 break-all whitespace-pre-wrap">
            {title}
          </p>
          <p className="text-[18px] text-[#121C59]/60 leading-[1.5] mt-1 line-clamp-1">
            {shareTitleList.join(' | ')}
          </p>
        </div>
        <div className="grid grid-cols-1 gap-y-[4px] text-[#121C59]/65 min-w-[120px] max-w-[180px] text-center flex-shrink-0">
          {sharePersonList.map((name, index) => (
            <p
              className="text-[18px] leading-[1.5] break-all line-clamp-1 font-300"
              key={index}
            >
              {name}
            </p>
          ))}
        </div>
      </div>
      {/* hover */}
      <div
        className={`w-full h-full flex flex-col justify-between py-[32px] pl-[48px] pr-[105px] ${
          active ? 'visible relative' : 'invisible absolute'
        }`}
      >
        <div className="text-white text-2xl">
          <div className="rounded-[100px] w-[172px] h-[52px] leading-[52px] bg-[url('https://cdn-digital.ssv.qq.com/upload//s2025/time-btn.png')] bg-no-repeat bg-cover text-center font-tcn1">
            {timeText}
          </div>
          <p className="flex-1 leading-[1.5] break-all w-[418px] mt-3 whitespace-pre-wrap">
            {title}
          </p>
        </div>
        <div className="text-white mt-3">
          {speaker.map((item) => (
            <p className="text-base break-all line-clamp-1" key={item.id}>
              {item.discussionTopic && (
                <span className="mr-4">
                  {getCMSIntlVal(item, 'discussionTopic', locale)}
                </span>
              )}
              <span className="">{getCMSIntlVal(item, 'name', locale)}</span>
              {item.title && (
                <>
                  <span className="mx-2 opacity-65">|</span>
                  <span className="opacity-65 font-300">
                    {getCMSIntlVal(item, 'title', locale).split(';')[0]}
                  </span>
                </>
              )}
            </p>
          ))}
        </div>
      </div>
      {/* 人像 */}
      {speakerImgUrl && (
        <Image
          className={`w-[460px] h-[292px] !absolute right-[24px] -top-[12px] transform-gpu opacity-0 scale-[0.3] ${
            active ? '!opacity-100 !scale-100' : ''
          } transition-all duration-500`}
          src={speakerImgUrl}
          loading={<></>}
          error={<></>}
          style={{ background: 'transparent' }}
          alt="meetingImg"
        ></Image>
      )}
    </div>
  );
};

const SessionInfoList = ({ list = [] }: { list: MeetingItem[] }) => {
  const [activeId, setActiveId] = useState(list[0]?.id);
  return (
    <div className="flex-1 flex flex-col gap-[12px]">
      {list.map((item) => (
        <SessionInfoItem
          key={item.id}
          item={item}
          active={activeId === item.id}
          onChange={() => {
            console.log('activeId', item.id);
            setActiveId(item.id);
          }}
        ></SessionInfoItem>
      ))}
    </div>
  );
};

export default SessionInfoList;
